import { render, staticRenderFns } from "./NnnFooter.vue?vue&type=template&id=71d34e3e&scoped=true&"
import script from "./NnnFooter.vue?vue&type=script&lang=ts&"
export * from "./NnnFooter.vue?vue&type=script&lang=ts&"
import style0 from "./NnnFooter.vue?vue&type=style&index=0&id=71d34e3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d34e3e",
  null
  
)

export default component.exports